import { BaseClient } from '../BaseClient';
import { getMimeType } from '../Common';
import {
  Diagnosis,
  DiagnosisList,
  DiagnosisStatus,
  DiagnosisStatusList,
  EquipmentDiagnosisHistory,
  EquipmentDiagnosisHistoryList,
  RefrigerantType,
  RefrigerantTypeList,
  ServiceItem,
  ServiceItemImage,
  ServiceItemImageList,
  ServiceItemList,
  SystemStatus,
  SystemStatusList,
} from '../compiled-protos/service_item';
import { ServiceItemServiceClient } from '../compiled-protos/service_item.client';
import { File as InternalFile, FileClient } from '../File';
import { S3Client, URLObject } from '../S3File';



class ServiceItemClient extends BaseClient {
  self: ServiceItemServiceClient;
  s3Client: S3Client;
  fileClient: FileClient
  readingImagesS3Bucket = 'kalos-service-item-images'

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new ServiceItemServiceClient(this.transport);
    this.s3Client = new S3Client(host, userID);
    this.fileClient = new FileClient(host, userID);
  }

  public async Create(req: ServiceItem) {
    const res = await this.self.create(req, this.getMetaData()).response;
    return res;
  }

  public async Get(req: ServiceItem) {
    const res = await this.self.get(req, this.getMetaData()).response;
    return res;
  }

  public async Update(req: ServiceItem) {
    const res = await this.self.update(req, this.getMetaData()).response;
    return res
  }

  public async Delete(req: ServiceItem) {
    const res = await this.self.delete(req, this.getMetaData()).response;
    return res;
  }

  public async BatchGet(req: ServiceItem) {
    const res = await this.self.batchGet(req, this.getMetaData()).response;
    return res;
  }

  public async Search(req: ServiceItem) {
    const res = await this.self.searchServiceItem(req, this.getMetaData()).response;
    return res;
  }

  public async CreateServiceItemImage({ req, file }: { req: Omit<ServiceItemImage, 'fileId' | 'fileBucket' | 'fileName'>, file: File }) {
    const fileKey = `${req.serviceItemId}-${Date.now()}-${file.name}`;
    const contentType = getMimeType(file.name);
    const urlObj = URLObject.create({
      bucket: this.readingImagesS3Bucket,
      key: fileKey,
      contentType,
    });
    const urlRes = await this.s3Client.GetUploadURL(urlObj);
    console.log({ urlRes })

    if (!urlRes) {
      throw new Error('Failed to get upload URL');
    }
    const uploadRes = await fetch(urlRes.url, {
      body: file,
      method: 'PUT',
    });
    console.log({ uploadRes })


    if (uploadRes.status !== 200) {
      throw new Error('Failed to upload file');
    }

    const fileObj = InternalFile.create({
      bucket: this.readingImagesS3Bucket,
      name: fileKey,
      mimeType: contentType,
    });
    const fileRes = await this.fileClient.Create(fileObj);
    console.log({ fileRes })

    return await this.self.createServiceItemImage(ServiceItemImage.create({ ...req, fileId: fileRes.id, imageName: fileRes.name }), this.getMetaData()).response;
  }

  public async CreateImage(req: ServiceItemImage) {
    const res = await this.self.createServiceItemImage(req, this.getMetaData()).response;
    return res;

  }
  public async GetImage(req: ServiceItemImage) {
    const res = await this.self.getServiceItemImage(req, this.getMetaData()).response;
    return res;
  }
  public async UpdateImage(req: ServiceItemImage) {
    const res = await this.self.updateServiceItemImage(req, this.getMetaData()).response;
    return res
  }
  public async DeleteImage(req: ServiceItemImage) {
    const res = await this.self.deleteServiceItemImage(req, this.getMetaData()).response;
    return res;
  }
  public async BatchGetImage(req: ServiceItemImage): Promise<ServiceItemImageList> {
    const res = await this.self.batchGetServiceItemImage(req, this.getMetaDataWithoutCache()).response;
    return res;
  }

  // Diagnosis methods
  public async CreateDiagnosis(req: Diagnosis) {
    const res = await this.self.createDiagnosis(req, this.getMetaData()).response;
    return res;
  }

  public async GetDiagnosis(req: Diagnosis) {
    const res = await this.self.getDiagnosis(req, this.getMetaData()).response;
    return res;
  }

  public async UpdateDiagnosis(req: Diagnosis) {
    const res = await this.self.updateDiagnosis(req, this.getMetaData()).response;
    return res;
  }

  public async DeleteDiagnosis(req: Diagnosis) {
    const res = await this.self.deleteDiagnosis(req, this.getMetaData()).response;
    return res;
  }

  public async BatchGetDiagnosis(req: Diagnosis): Promise<DiagnosisList> {
    const res = await this.self.batchGetDiagnosis(req, this.getMetaData()).response;
    return res;
  }

  public async BatchGetDiagnosisStatus(req: DiagnosisStatus): Promise<DiagnosisStatusList> {
    const res = await this.self.batchGetDiagnosisStatus(req, this.getMetaData()).response;
    return res;
  }

  public async BatchGetSystemStatus(req: SystemStatus): Promise<SystemStatusList> {
    const res = await this.self.batchGetSystemStatus(req, this.getMetaData()).response;
    return res;
  }

  public async BatchGetEquipmentDiagnosisHistory(
    req: EquipmentDiagnosisHistory,
  ): Promise<EquipmentDiagnosisHistoryList> {
    const res = await this.self.batchGetEquipmentDiagnosisHistory(req, this.getMetaData()).response;
    return res;
  }

  public async BatchGetRefrigerantType(req: RefrigerantType): Promise<RefrigerantTypeList> {
    const res = await this.self.batchGetRefrigerantType(req, this.getMetaData()).response;
    return res;
  }
}

export {
  Diagnosis,
  DiagnosisList,
  DiagnosisStatus,
  DiagnosisStatusList,
  EquipmentDiagnosisHistory,
  EquipmentDiagnosisHistoryList,
  RefrigerantType,
  RefrigerantTypeList,
  ServiceItem,
  ServiceItemClient,
  ServiceItemImage,
  ServiceItemImageList,
  ServiceItemList,
  SystemStatus,
  SystemStatusList,
};
